export const SELF = "00";
export const MATE = "01";
export const CHILD = "03";

export default {
  [SELF]: "本人",
  [MATE]: "配偶",
  [CHILD]: "子女",
}